// src/settingComponent/apiSetting/apiPages/ApiPrivacyPolicy.js
import React from 'react';
import { Helmet } from 'react-helmet';
import '../../../unAuthPages/TermsOfService.css';
import Footer from '../../../unAuthPages/Footer';

const ApiPrivacyPolicy = () => {
  return (
    <div className="terms-container">
      <Helmet>
        <title>Bumpups: API Privacy Policy</title>
        <meta
          name="description"
          content="Learn how Bumpups collects, uses, and protects information when you use our API."
        />
      </Helmet>

      <h1 className="terms-title">Bumpups API Privacy Policy</h1>
      <div className="terms-text-container">
        <p><strong>Last Updated:</strong> June 8, 2025</p>

        <h3>1. Introduction</h3>
        <p>
          This Privacy Policy explains how Bumpups Inc. (“Bumpups”) collects, uses, and protects information in connection with your use of our APIs, video analysis services, developer tools, and related offerings (collectively, the “Services”). By accessing or using our Services, you agree to the collection and use of information in accordance with this Privacy Policy.
        </p>

        <h3>2. Information We Collect</h3>
        <h4>2.1 Account Information</h4>
        <p>
          When you create an API key or register for our Services, we collect personal and business information (e.g., name, email address) necessary to manage your account.
        </p>
        <h4>2.2 Usage Data</h4>
        <p>
          We collect data on your interactions with our APIs (e.g., request logs, error reports, and performance metrics) to monitor, maintain, and improve our Services.
        </p>
        <h4>2.3 Customer Content</h4>
        <p>
          Any data or content you submit to our Services (e.g., video URLs, text input) is processed to generate the corresponding output. This content is handled according to our privacy commitments.
        </p>

        <h3>3. How We Use Your Information</h3>
        <ul>
          <li><strong>To Provide and Improve Our Services:</strong> Operate, maintain, and enhance the performance of our APIs.</li>
          <li><strong>To Communicate with You:</strong> Send updates about changes to our services, security notices, and administrative messages.</li>
          <li><strong>For Analytics and Monitoring:</strong> Optimize our services and identify areas for improvement.</li>
        </ul>

        <h3>4. Sharing and Disclosure of Information</h3>
        <h4>4.1 Third-Party Service Providers</h4>
        <p>
          We may share information with trusted vendors who support our business operations (e.g., hosting, data analytics). These providers are required to protect your data and use it only for the purposes specified by Bumpups.
        </p>
        <h4>4.2 Legal Compliance</h4>
        <p>
          We may disclose your information if required to do so by law or in the good faith belief that such action is necessary to comply with legal obligations.
        </p>
        <h4>4.3 Business Transfers</h4>
        <p>
          In the event of a merger, acquisition, or asset sale, your information may be transferred as part of the transaction, subject to applicable confidentiality obligations.
        </p>

        <h3>5. Data Security</h3>
        <p>
          Bumpups employs industry-standard security measures to protect your information from unauthorized access, disclosure, alteration, and destruction. These include:
        </p>
        <ul>
          <li>Secure data storage and transmission protocols.</li>
          <li>Regular risk assessments and security audits.</li>
          <li>Access controls and multi-factor authentication for internal systems.</li>
        </ul>

        <h3>6. International Data Transfers</h3>
        <p>
          Your information may be transferred to and maintained on servers located outside your country of residence. We take steps to ensure that such data transfers comply with applicable privacy and data protection laws.
        </p>

        <h3>7. Data Retention</h3>
        <p>
          We retain your personal and usage data for as long as necessary to fulfill the purposes outlined in this policy. Once the data is no longer required, it will be securely deleted or anonymized.
        </p>

        <h3>8. Your Rights and Choices</h3>
        <p>
          Depending on your jurisdiction, you may have rights regarding your personal data, including:
        </p>
        <ul>
          <li>The right to access or request a copy of your data.</li>
          <li>The right to request correction or deletion of your data.</li>
          <li>The right to restrict or object to certain data processing activities.</li>
        </ul>
        <p>
          To exercise your rights or if you have any questions, please contact us at{' '}
          <a href="mailto:contact@bumpups.com" className="policyLinks">
            contact@bumpups.com
          </a>.
        </p>

        <h3>9. Changes to This Privacy Policy</h3>
        <p>
          We may update this Privacy Policy from time to time. When we do, we will post the updated policy on our website and update the “Last Updated” date. Your continued use of our Services after any changes indicates your acceptance of the new policy.
        </p>

        <h3>10. Contact Information</h3>
        <p>
          If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us at:
        </p>
        <p>
          Bumpups Inc.<br/>
          5473 Blair Rd Ste 100 #112725<br/>
          Dallas, TX 75231-4227<br/>
          Email:{' '}
          <a href="mailto:contact@bumpups.com" className="policyLinks">
            contact@bumpups.com
          </a>
        </p>
      </div>

      <Footer />
    </div>
  );
};

export default ApiPrivacyPolicy;
